<div
  class="flex-col notification-list fixed top-0 right-0 p-6"
  [ngClass]="{ hidden: notifications.length === 0, flex: notifications.length > 0 }"
>
  <app-notification
    class="notification-list__item"
    [notification]="notification"
    (remove)="removeNotification($event)"
    *ngFor="let notification of notifications"
  >
  </app-notification>
</div>
